// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3ZT3m","content":"styles_content__29Y4y","checkbox":"styles_checkbox__2Dcxj","checkboxLabel":"styles_checkboxLabel__3ktBJ"};